<template>
  <div class="section meals">
    <div class="section__header">Kolejność, czas i założona kaloryczność posiłków</div>
    <div class="energy-distribution-switch" @click="emit('toggleDistribution')">
      <label class="energy-distribution-switch__label">Rozkład energii</label>
      <BaseSwitch :value="energyDistribution" />
    </div>
    <div class="meals__content">
      <div class="meal-header" :class="{ 'energy-distribution': energyDistribution }">
        <div class="meal-header__hour">Godzina</div>
        <div>Nazwa</div>
        <div>Typ posiłku</div>
        <div v-if="energyDistribution">Rozkład energii</div>
      </div>
      <MealRow
        v-for="(meal, index) in meals"
        :key="index"
        :calories-for-distribution="caloriesForDistribution"
        :can-delete="meals.length > 1"
        :energy-distribution="energyDistribution"
        :hour-options="hourOptions"
        :index="index"
        :meal="meal"
        @delete="emit('delete', $event, meal.name)"
      />
      <div v-if="meals.length < 12" class="create-meal">
        <StyledButton
          left-icon="add"
          class="base-button--secondary base-button--outline"
          @click="emit('create')"
        >
          Dodaj pozycję
        </StyledButton>
      </div>
    </div>
    <BaseModal v-if="deleteOpen" @close="emit('closeDelete')">
      <template #title>Usuwanie posiłku</template>
      <div v-if="selectedMealName" class="delete-confirmation-text">
        Czy chcesz usunąć posiłek o nazwie <span>{{ selectedMealName }}</span>
        ?
      </div>
      <div v-else>Czy chcesz usunąć wybrany posiłek?</div>
      <template #actions>
        <StyledButton variant="outline" @click="emit('closeDelete')">Anuluj</StyledButton>
        <StyledButton @click="emit('confirmDelete')">Usuń</StyledButton>
      </template>
    </BaseModal>
  </div>
</template>

<script lang="ts" setup>
  import BaseModal from '@/components/BaseModal.vue'
  import BaseSwitch from '@/components/BaseSwitch.vue'
  import { StyledButton } from '@/components/StyledButton'

  import type { DietData } from '@/types/Diet'

  import MealRow from '../MealRow/MealRow.vue'

  defineProps<{
    caloriesForDistribution: (value: number) => number
    deleteOpen: boolean
    energyDistribution: boolean
    hourOptions: { text: string; value: string }[]
    meals: DietData['meals']
    selectedMealName: string
  }>()
  const emit = defineEmits<{
    closeDelete: []
    confirmDelete: []
    create: []
    delete: [index: number, name: string]
    toggleDistribution: []
  }>()
</script>

<style lang="scss">
.delete-confirmation-text span {
  font-family: Montserrat-SemiBold;
}
</style>
